import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'
import { setOnlineInterval } from '../redux/FeedbackRedux';

class OnlineUsersV2 extends React.Component {

	componentDidMount(){
		//this.props.dispatch(setOnlineInterval());
		//make this work without rerendering the whole page every time.
	}

	render () {
		var online_users;
		if(this.props.online_users && this.props.online_users.length > 0){
			online_users = 
				<div className="dropdown">
					<button className="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						<span className="header-text"> { __('Active Users') } </span>
					</button>
					<div className="dropdown-menu active-users" aria-labelledby="dropdownMenuButton">
						{ this.props.online_users.map((value,index) => {
							//console.log("mapping");
								var dotStyle = {color: "gray"};
								var itemStyle = {fontWeight: 700};
								var web = (value.last_web_activity ? Date.parse(value.last_web_activity + " UTC") : 0);
								var api = (value.last_api_activity ? Date.parse(value.last_api_activity + " UTC") : 0);
								var t = new Date();
								var tt = new Date();
								var ten_mins_ago = new Date(t.getTime() - (5*60000)).getTime();
								var two_hours_ago = new Date(tt.getTime() - (120*60000)).getTime();
								var name = (value.firstname+" "+value.lastname).trim();
								var classes = "dropdown-item pl-2";
								//console.log(name+ " Ten Mins Ago: "+ new Date(ten_mins_ago));
								//console.log(name+ " Two Hours Ago: "+two_hours_ago);
								//console.log(name+ " Web: "+new Date(web));
								//console.log(name+ " API: "+new Date(api));
								var greater;
								if(web > ten_mins_ago || api > ten_mins_ago){
									//console.log(name+ " its sooner than ten minutes ago");
									dotStyle.color = "#30b11b";
									classes += " is-active";
								} else {
									classes += " is-inactive";
								}
								var icon;
								if(api > web) {
									icon = <i className="fas fa-mobile-alt"></i>;
									greater = api;
									classes += " mobile";
									//console.log(name + " api is greater");
								} else {
									icon = "⬤";
									greater = web;
									classes += " desktop";
									//console.log(name + " web is greater");
								}
								if(greater < two_hours_ago){
									//console.log(name + " activity is too old");
									classes += " is-logged-out";
									itemStyle = {opacity: "0.5"};
								}
								//console.log("activity is good enough");
								//console.log(name+ "dot style");
								//console.log(dotStyle);
								var dot = <span className="mr-2" style={dotStyle}>{icon}</span>
								return (<div style={itemStyle} className={classes} key={index} id={value.user_id} href="#">{dot}{name}</div>);
							})
						}
					</div>
				</div>;
		} else {
			online_users = 
				<div className="dropdown">
					<button className="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						<span className="header-text"> { __('Active Users') } </span>
					</button>
					<div className="dropdown-menu active-users" aria-labelledby="dropdownMenuButton">
						<div className="dropdown-item pl-2 is-inactive text-center" key={1} id={null} href="#">{__('None...')}</div>
					</div>
				</div>;
		}
		return (online_users);
	}
}

function mapStateToProps(state) {
	return { online_users:state.online_users }
}

export default connect(mapStateToProps)(OnlineUsersV2);
